module.exports = __webpack_public_path__ + "img/4-bn.d134697d.png";